import { render, staticRenderFns } from "./proses.vue?vue&type=template&id=7479f3b1"
import script from "./proses.vue?vue&type=script&lang=js"
export * from "./proses.vue?vue&type=script&lang=js"
import style0 from "./proses.vue?vue&type=style&index=0&id=7479f3b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports